module.exports = __webpack_public_path__ + "static/img/dCT6.54edc7f4.png";